





































































// Définir une interface pour les éléments
interface ParticipationElement {
    uuid: string;
    approvedAt: string | null;
    refusedAt: string | null;
    hierarchyOwner: {
        brand: {
            fullName: string;
        }
        clientCode1: string;
        fullName: string;
    };
    campaign: {
        formattedWeek: string;
        startDate: string;
        endDate: string;
        externalCode: string;
        label: string;
    };
    validationDeadline: string;
}

import Component from "vue-class-component";
import StandardList from "front-component/components/List.vue";
import ParticipationRepository from "@/repositories/socle/ParticipationRepository";
import SocleAnabel from "./fields/Anabel.vue";
import SocleBudgetHierarchyFullName from "./fields/HierarchyFullName.vue";
import SocleBudgetIsValidated from "./fields/isValidated.vue";
import SocleBudgetLabel from "./fields/BudgetLabel.vue";
import SocleBudgetValidationDeadline from "./fields/ValidationDeadline.vue";
import SocleCampaignCode from "./fields/CampaignCode.vue";
import SocleCampaignLabel from "./fields/BudgetCampaignLabel.vue";
import SocleFormattedWeek from "./fields/FormattedWeek.vue";
import SocleSubHierarchy from "./fields/SubHierarchy.vue";
import SocleStoreStatus from "./fields/StoreStatus.vue";
import _ from "lodash";
import moment from "moment";

enum ParticipationAction {
    APPROVE = "approve",
    REFUSE = "refuse"
}

const components = {
    SocleAnabel,
    SocleBudgetIsValidated,
    SocleBudgetHierarchyFullName,
    SocleBudgetValidationDeadline,
    SocleCampaignCode,
    SocleCampaignLabel,
    SocleFormattedWeek,
    SocleSubHierarchy,
    SocleStoreStatus,
    SocleBudgetLabel,
};

@Component({ components })
export default class List extends StandardList {
    public loading: boolean = false;
    public elements: ParticipationElement[] = [];
    private readonly DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

    public created(): void {
        window.addEventListener("scroll", this.handleScroll);
        this.fields = ParticipationRepository.defaultFields;
    }

    protected link() {
        return ParticipationRepository.getSearchUrl();
    }

    public isValidationDeadlinePassed(operation: ParticipationElement): boolean {
        const validationDl = moment(operation.validationDeadline).set("hour", 23).set("minute", 59);
        const currentD = moment();

        return validationDl < currentD;
    }

    public handleStatusChanged(uuid: string, action: string): void {
        const now = moment().format("YYYY-MM-DD HH:mm:ss");
        this.$confirm(_.invoke(this.$options.filters, "trans", "confirmValidationParticipation"))
            .then(() => {
                const socleParticipation = {
                    uuid,
                    approvedAt: ParticipationAction.REFUSE === action ? null : now,
                    refusedAt: ParticipationAction.REFUSE === action ? now : null,
                };

                ParticipationRepository.save(socleParticipation).then((data: object) => {
                    this.refreshList();
                });
                return;
            })
            .catch(() => {
                return;
            })
        ;
    }

    private handleScroll() {
        const fadeElement: any = document.querySelector(".selectedBadge");
        if (window.scrollY > 0) {
            if (fadeElement) {
                fadeElement.style.display = "none";
            }
        } else {
            if (fadeElement) {
                fadeElement.style.display = "block";
            }
        }
    }
}
